// extracted by mini-css-extract-plugin
export default {"card":"AboutCard_card__ybYwm","content":"AboutCard_content__5mxeM","icon":"AboutCard_icon__VJVRq","animate":"AboutCard_animate__jCxex","text":"AboutCard_text__9h0EJ"};